import React from 'react'
import { Share, X } from 'lucide-react'
import styles from './homeScreenNudge.module.scss'

// After the wallet setup, on iOS browsers: keeping Treechat on the Home Screen keeps
// the browser wallet on this phone (see lib/homeScreenNudge).
export default function HomeScreenNudge({ onDismiss }: { onDismiss: () => void }) {
    return (
        <div className={styles.nudge} role="dialog" aria-label="Add Treechat to your Home Screen">
            <button type="button" className={styles.close} onClick={onDismiss} aria-label="Close">
                <X size={18} aria-hidden="true" />
            </button>
            <p className={styles.title}>
                Add Treechat to your Home Screen for improved wallet management
            </p>
            <p className={styles.how}>
                Tap <Share size={16} aria-label="Share" className={styles.shareIcon} />, then Add to
                Home Screen.
            </p>
            <button
                type="button"
                className={styles.gotIt}
                onClick={onDismiss}
                data-testid="home-screen-nudge-dismiss"
            >
                Got it
            </button>
        </div>
    )
}
